import React, { useEffect, useState } from "react";
import peliculas from "../db.json";
import { useParams } from "react-router-dom";
import estilo from "../styles/Detalles.module.css";
import MetaDecorator from "../utils/MetaDecorator";
import Comentarios from "../components/Comentarios";

function Detalles() {
  const params = useParams();
  const numeroP = params.id;
  // console.log(numeroP);
  const recorrido = peliculas
    .map(
      ({
        id,
        titulo,
        portada,
        año,
        calificacion,
        duracion,
        generos,
        sinopsis,
        trailer,
        servidores,
      }) => ({
        id: `${id}`,
        titulo,
        portada,
        año,
        calificacion,
        duracion,
        generos: `${generos.map((g) => g.nombre).join(", ")}`,
        sinopsis,
        trailer,
        servidores,
      })
    )
    .find((e) => e.id === numeroP);
  // console.log(recorrido);
  //Servidores de video
  const [servidorVideo, setServidorVideo] = useState();
  const onChangeCombo = (e) => {
    const selectId = e.target.value;
    const selectServidorVideo = recorrido.servidores.filter(
      (e) => e.nombre === selectId
    )[0];
    // console.log(selectServidorVideo);
    setServidorVideo(selectServidorVideo);
  };
  useEffect(() => {
    setServidorVideo(recorrido.servidores[0]);
  }, []);
  return (
    <div className={estilo.detalles}>
      <MetaDecorator
        titulo={"Ver " + recorrido.titulo + " en linea | RepelisPlus"}
        subtitulo={recorrido.titulo}
        descripcion={recorrido.sinopsis}
      />

      <div className={estilo.linea}></div>
      <div className={estilo.detalles_pelicula}>
        <div className={estilo.detalles_portada}>
          <img src={recorrido.portada} alt={recorrido.titulo} />
        </div>

        <div className={estilo.detalles_informacion}>
          <div className={estilo.informacion_a}>
            <h2>{recorrido.titulo}</h2>

            <div className={estilo.fecha_duracion}>
              <span>{recorrido.año}</span>
              <span>{recorrido.duracion} min</span>
            </div>
          </div>

          <div className={estilo.informacion_b}>
            <p>
              <b>Calificación: </b>
              {recorrido.calificacion}
            </p>
          </div>

          <div className={estilo.informacion_c}>
            <h3>{recorrido.titulo} | PelisPlus.com</h3>
            <span>
              <b>Géneros: </b>
              {recorrido.generos}
            </span>
            <p>
              <b>Sinopsis: </b>
              {recorrido.sinopsis}
            </p>
          </div>
        </div>
      </div>

      <div className={estilo.detalles_servidores}>
        <div>
          <select
            onChange={(e) => {
              onChangeCombo(e);
            }}
          >
            {recorrido.servidores.map((e) => (
              <option value={e.nombre}>{e.nombre}</option>
            ))}
          </select>
        </div>

        <div className={estilo.reproductor}>
          {servidorVideo ? (
            <iframe
              src={servidorVideo.servidor}
              allowfullscreen="true"
              frameborder="0"
              title={recorrido.titulo}
            ></iframe>
          ) : (
            ""
          )}
        </div>
      </div>
      <Comentarios></Comentarios>
    </div>
  );
}

export default Detalles;
